export default __webpack_public_path__ + "static/media/skills.328fdc96.png";